<div class="data-filter">
    <label [i18n]="[{target: 'innerHTML', key: labelKey}]">
    </label>
    <span *ngIf="required" class="required-asterisk">*</span>
    <input class="form-control"
           [class.falsely-disabled]="!disabled"
           [disabled]="disabled"
           [dpDayPicker]="config"
           [i18n]="[{target: 'attribute:placeholder', key: placeholderKey}]"
           [theme]="'date-time-picker'"
           [(ngModel)]="modelString"
           (onSelect)="select($event)">
</div>
